module.exports = __webpack_public_path__ + "img/11.a24440de.png";